import React, { Component } from 'react';
import { Col } from 'react-bootstrap';
import './defaultHeader.scss';

/*-- Import required components --*/
import CartBox from './CartBox';
import ProductSearch from '../productSearch/ProductSearch';
import NexusIcon from '../../assets/img/icons/Nexus_icon.png';
import PremiumIcon from '../../assets/img/icons/Premium_icon.png';
import KeellsLogo from '../../assets/img/logo/KeellsWhiteLogo.png';
import { UserGuider } from './../common';

/*-- Imports for redux --*/
import { connect } from 'react-redux';
import { showMessageBox, resetMessageBox } from '../../redux/actions/messageBoxActions';
import NavBarMobileView from './NavBarMobileView';
import NotificationStripe from '../notificationHub/NotificationStripe';

/*-- Map the redux states to props --*/
function mapStateToProps(state) {
    return {
        shoppingPreference: state.shoppingPreference,
        userDetails: state.userDetails
    }
};

/*-- Map the redux actions to props --*/
const mapDispatchToProps = {
    showMessageBox,
    resetMessageBox
};

class DefaultHeaderDesktop extends Component {

    constructor(props) {
        super(props);
        this.RefUserIcon = React.createRef();
        this.state = {
            viewType: '',
            isMobileNavBarVisible: false,
            mobileViewKey: 0,
        }
    }
    Toggle(type) {
        this.setState(prevState => (
            {
                isMobileNavBarVisible: true,
                viewType: type,
                mobileViewKey: prevState.mobileViewKey + 1
            }
        ));
    }

    showNexusLogo() {
        let showNexusLogo = false;
        if (this.props.userDetails.isNexus) {
            if (this.props.userDetails.isPremiumCustomer) {
                showNexusLogo = false;
            } else {
                showNexusLogo = true;
            }
        } else {
            showNexusLogo = false;
        }

        return showNexusLogo;
    }

    render() {
        return (
            <div className="default-header-container">
                <UserGuider
                    name='UserIcon'
                    target={this.RefUserIcon}
                    placement='bottom'
                    content='We seem to have an incomplete record for you. Please update your account now.'
                />
                <NotificationStripe />
                <div className="default-header-navbar">
                    {/* Panel with logo */}

                    <Col md={{ span: 10, offset: 1 }} className='pt-3 d-flex'>
                        {/* logo */}
                        <Col md='2' className='set-to-center'>
                            <a href={`${window.location.origin}/`}>
                                <img src={KeellsLogo} className="img-fluid"></img>
                            </a>
                        </Col>

                        <Col md='10' className='set-to-center justify-content-end'>
                            <div className='mobile-view-nav-bar'>
                                <CartBox />
                                <div onClick={this.Toggle.bind(this, 'user')}>
                                    <i className="fas fa-user">
                                        <img
                                            src={NexusIcon}
                                            title="Nexus Member"
                                            alt="nexus_icon"
                                            style={{ display: this.showNexusLogo() ? "" : "none", width: "20px", height: "19px" }}>
                                        </img>
                                        <img
                                            src={PremiumIcon}
                                            title="Long standing Nexus Member"
                                            alt="premium_icon"
                                            style={{ display: this.props.userDetails.isPremiumCustomer ? "" : "none", width: "20px", height: "19px" }}>
                                        </img>
                                    </i>
                                    {!this.props.userDetails.isDetailsCompleted && !this.props.userDetails.isGuest
                                        ? <i className="fas fa-exclamation" ref={this.RefUserIcon} style={{ color: 'red', fontSize: '15px' }} title="We seem to have an incomplete record for you. Please update your account now."></i> : null}
                                </div>
                                <div className='nav-item-highlighted' onClick={this.Toggle.bind(this, 'menu')}>
                                    <i className="fas fa-bars" />
                                </div>
                            </div>
                        </Col>
                    </Col>
                    {/* product search */}
                    <Col md={{ span: 10, offset: 1 }}>
                        <ProductSearch />
                    </Col>
                </div>

                <NavBarMobileView
                    key={this.state.mobileViewKey}
                    type={this.state.viewType}
                    visible={this.state.isMobileNavBarVisible}
                    userDetails={this.props.userDetails}
                    shoppingPreference={this.props.shoppingPreference}
                    logout={this.props.logout}
                    login={this.props.login}
                />
            </div>
        )
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(DefaultHeaderDesktop);
